import { Typography, Button, Box, Grid } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { OrganizationsClient, OrganizationResponseDTO } from '../generated/ApiClient'
import MUIDataTable from "mui-datatables";
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import { tableOptions as options } from '../common/Shared'
import { useIsUserInRoles } from '../hooks/useIsUserInRoles';

interface OrganizationTableData {
    name: string;
    agencyNumber: string;
    externalId: string;
}

export default function Organizations() {
    const [orgData, setOrgName] = useState<OrganizationTableData[]>([]);
    const isGlobalAdmin = useIsUserInRoles(['GlobalAdmin'])
    const tableOptions = {
        ...options,
        onRowsDelete: ((rowsDeleted: { lookup: any; data: { index: number; dataIndex: number; }[]; }, data: OrganizationTableData[]) => {
            const selectedIndexs = rowsDeleted.data.map((row) => row.dataIndex);
            const orgIds: string[] = selectedIndexs.map((index) => orgData![index].externalId);
            removeOrganizations(orgIds);
        })
    }

    const dispatch = useDispatch()
    const removeOrganizations = async (orgIds: string[]) => {
        try {
            await Promise.all(orgIds.map((orgId) => removeOrganization(orgId)));
            dispatch(snackbar.addMessage({ title: "Success", message: `Organizations successfully removed`, alertType: 'success' }))
            const newOrgData = orgData.filter(x => !orgIds.includes(x.externalId));
            setOrgName(newOrgData);
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }
    const removeOrganization = async (orgId: string) => {
        try {
            await new OrganizationsClient().delete(orgId);
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }

    const columns = [
        {
            name: "name",
            label: "Organization",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "agencyNumber",
            label: "Agency Number",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: 'detailsButton',
            label: 'View',
            options: {
                sort: false,
                filter: false,
                customBodyRenderLite: (dataIndex: number) => {
                    const link = `/organizations/${orgData[dataIndex].externalId}`;
                    return <Button component={RouterLink} variant='contained' size='small' to={link}>View</Button>
                }
            }
        },
    ];

    function toTableData(orgData: OrganizationResponseDTO) {
        return { name: orgData.name || " N/A ", agencyNumber: orgData.agencyNumber || " N/A ", externalId: orgData.externalId || " N/A " }
    }

    useEffect(() => {
        const fetchData = async () => {
            const orgData = await new OrganizationsClient().getMany();
            setOrgName(orgData.map(toTableData));
        }
        fetchData();
    }, [])

    return (
        <>
            <Typography variant='h4' id="tabelLabel">Organizations</Typography>
            {isGlobalAdmin &&
                <Grid container item direction='column' spacing={2} alignItems='flex-end'>
                    <Box my={2}>
                        <Button component={RouterLink} variant='contained' color='primary' size='medium' to={`/organizations/create`}>+ Create</Button>
                    </Box>
                </Grid>}
            <MUIDataTable
                title={""}
                data={orgData}
                columns={columns}
                options={tableOptions}
            />
        </>
    )
}